export default __webpack_public_path__ + "static/media/hudsonlogos-01.f3eec696.png";